import { createContext } from '@chakra-ui/react-utils';

interface InputGroupWithSuggestionsContextTypes {
  availableSuggestions: boolean;
  acceptedSuggestion: boolean;
  isDisabled: boolean;
}

export const [
  InputGroupWithSuggestionsProvider,
  useInputGroupWithSuggestionsContext,
] = createContext<InputGroupWithSuggestionsContextTypes>({
  strict: false,
  name: 'InputGroupWithSuggestionsContext',
});
